(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["imagestack"] && !Shopify.designMode) return;
  try {
    
/* Add your custom scripts here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-animate-v1"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("scroll", function() {
    const logoSection = document.querySelector("#{{ section_id }}");
    const abpvrSection = document.querySelector(".section.abpvr");
    if (logoSection && abpvrSection) {
      const logoHeight = logoSection.offsetHeight;
      const abpvrOffsetTop = abpvrSection.offsetTop;
      const scrollTop = window.scrollY;

      if (scrollTop > abpvrOffsetTop - logoHeight) {
        logoSection.style.top = `${abpvrOffsetTop - scrollTop}px`;
      } else {
        logoSection.style.top = "100px"; /* Reset to initial position */
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');

						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}

						if (html.querySelector('.product')) {
							this.classList.add('product-recommendations--loaded');
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 150px 0px'}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
